<template>
  <div>
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="overlay" :class="[request_drawer ? 'overlay open' : 'overlay']" @click="closeDrawer()"></div>
    <div :class="[request_drawer ? 'pr-detail-modal open' : 'pr-detail-modal']">
      <div class="request-pr-wrap" v-if="request_drawer">
        <div class="request-pr-title" style="font-size: 16px">
          新規登録リクエスト
        </div>
        <div class="request-pr-form">
          <div class="request-pr-form-wrap">
            <div class="request-pr-form-parts top" style="flex-flow: column">
              <span style="font-weight:700">
                {{ siteName }} に未登録のインフルエンサーの新規登録をリクエストします。
              </span>
            </div>
            <div class="request-pr-form-parts">
              <div class="request-pr-form-subtitle">プラットフォーム</div>
              <div class="create-report-sns small" @click="$emit('update:sns_type', 'instagram')" :class="sns_type == 'instagram' ? 'active' : ''">
                <div class="create-report-sns-title">
                  Instagram
                </div>
                <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="sns_type == 'instagram'" /></div>
                <img class="create-report-sns-image small" src="../../assets/ig_icon.png" alt />
              </div>
              <div class="create-report-sns small right" @click="$emit('update:sns_type', 'youtube')" :class="sns_type == 'youtube' ? 'active' : ''">
                <div class="create-report-sns-title">
                  YouTube
                </div>
                <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="sns_type == 'youtube'" /></div>
                <img class="create-report-sns-image small" src="../../assets/yt_icon.png" alt />
              </div>
              <div class="create-report-sns small right" @click="$emit('update:sns_type', 'tiktok')" :class="sns_type == 'tiktok' ? 'active' : ''">
                <div class="create-report-sns-title">
                  TikTok
                </div>
                <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="sns_type == 'tiktok'" /></div>
                <img class="create-report-sns-image small" src="../../assets/tt_icon.png" alt />
              </div>
              <div class="create-report-sns small right" @click="$emit('update:sns_type', 'twitter')" :class="sns_type == 'twitter' ? 'active' : ''">
                <div class="create-report-sns-title">
                  X
                </div>
                <div class="create-list-check" ><font-awesome-icon :icon="['fas', 'check-circle']" v-show="sns_type == 'twitter'" /></div>
                <img class="create-report-sns-image small" src="../../assets/tw_icon.png" alt />
              </div>
            </div>
            <div class="request-pr-form-parts">
              <div class="request-pr-form-subtitle">
                リクエストタイトル
                <el-tooltip>
                  <div slot="content">識別用にリクエストのタイトルを設定できます</div>
                  <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px;" />
                </el-tooltip>
              </div>
              <el-input type="text" v-model="request_title" placeholder="etc) 2021/4/1リクエスト分" maxlength="50" show-word-limit id="autoFocus"></el-input>
            </div>
            <div class="request-pr-form-parts">
              <div class="request-pr-form-subtitle">リクエストアカウント</div>
              <div style="flex-flow:column; width:100%; position:relative">
                <el-input class="influencer-suggest-textarea" v-model="request_value" @input="syncInfluencerBulk()" type="textarea" :rows="12"></el-input>
                <div class="influencer-suggest-textarea-placeholder" style="left:15px" v-if="!request_value">
                  <div v-if="sns_type == 'instagram'">
                    ユーザー名もしくはユーザーURLを1行ごとに入力してください
                    <br />
                    <br />(例) <br />https://www.instagram.com/kimkardashian/ <br />https://www.instagram.com/justinbieber/ <br />https://www.instagram.com/cristiano/ <br />... <br />kimkardashian
                    <br />justinbieber <br />cristiano <br />...
                    <br />
                  </div>
                  <div v-if="sns_type == 'youtube'">
                    チャンネルのURLを1行ごとに入力してください
                    <br />
                    <br />(例) <br />https://www.youtube.com/user/0214mex <br />https://www.youtube.com/user/HikakinTV <br />...<br />https://www.youtube.com/channel/UCutJqz56653xV2wwSvut_hQ
                    <br />https://www.youtube.com/channel/UCaminwG9MTO4sLYeC3s6udA <br />...<br />https://www.youtube.com/@hajimesyacho<br />https://www.youtube.com/@HikakinTV
                    <br />
                  </div>
                  <div v-if="sns_type == 'tiktok'">
                    ユーザー名もしくはユーザーURLを1行ごとに入力してください
                    <br />
                    <br />(例) <br />https://www.tiktok.com/@kageihina <br />https://www.tiktok.com/@junya1gou <br />https://www.tiktok.com/@bayashi.tiktok <br />... <br />kageihina <br />junya1gou
                    <br />bayashi.tiktok <br />...
                    <br />
                  </div>
                  <div v-if="sns_type == 'twitter'">
                    ユーザー名もしくはユーザーURLを1行ごとに入力してください
                    <br />
                    <br />(例) <br />https://x.com/elonmusk <br />https://x.com/MINAMI373HAMABE <br />https://x.com/NANAO1028 <br />... <br />elonmusk
                    <br />MINAMI373HAMABE <br />NANAO1028 <br />...
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="request-pr-form-parts">
              <div class="request-pr-form-subtitle">登録完了時のメール通知</div>
              <div style="flex-flow:row; margin-top:10px">
                <el-radio v-model="email_is_required" :label="false">通知しない</el-radio>
                <el-radio v-model="email_is_required" :label="true">通知する</el-radio>
              </div>
            </div>
            <div class="request-pr-form-parts" v-if="email_is_required">
              <div class="request-pr-form-subtitle">通知先メールアドレス</div>
              <div style="flex-flow:column; width:100%">
                <el-input v-model="email_to" placeholder="" @change="verifyEmail()"></el-input>
              </div>
            </div>
            <div class="divider"></div>
            <div style="padding:10px 30px; font-size:12px; font-weight:600; line-height:1.8;">
              <li>※リクエストは弊社で内容確認の上、順次登録を行うため1~2営業日程度お時間を頂戴します。</li>
              <li>※ユーザー名が正確でない場合や、SNS選択が誤っている場合、登録不可となります。</li>
              <li>※非公開または利用制限を受けているアカウントについても登録不可となります。</li>
              <li>※フォロワー数・チャンネル登録者数が1,000人未満のアカウントは登録対象外となります。</li>
              <li>※一度に500件以上の登録はご遠慮ください。</li>
              <li>※登録数が多いリクエストは取得開始まで時間がかかる場合があります。</li>
              <li v-if="sns_type == 'youtube'">※チャンネルのURLは次の手順で取得してください。<br>&emsp;プロフィール概要欄の「...更に表示」をクリック→「チャンネルを共有」→「コピー」</li>
            </div>
          </div>
          <div class="request-pr-form-buttonarea">
            <el-button type="primary" @click="request()" :disabled="loading">
              <div class="flex-row">
                リクエストする
                <div class="loader--mini" v-show="loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const requestAPI = root + "/api/request/request";
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "requestDrawer",
  props: {
    request_drawer: { type: Boolean, default: false },
    influencer_bulk: { type: String, default: "" },
    sns_type: { type: String, default: "instagram" },
  },
  components: {
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      request_title: "",
      request_value: "",
      loading: false,
      email_is_required: false,
      email_to: "",
      requestId: 0,
      siteName: "REECH DATABASE"
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    email() {
      return this.$store.state.email;
    },
    email_private() {
      return this.$store.state.email_private;
    },
    youtube_channel_url_error() {
      if (this.sns_type == "youtube") {
        let influencers = this.influencer_bulk.split("\n");
        for (let i = 0; i < influencers.length; i++) {
          if (!influencers[i].match(/youtube\.com\/(channel|user|c|@)/) && influencers[i] != "") {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    other_sns_error() {
      if (this.sns_type == "instagram" && this.influencer_bulk.match(/youtube\.com|tiktok\.com|twitter\.com|x\.com/)) {
        return true;
      } else if (this.sns_type == "youtube" && this.influencer_bulk.match(/instagram\.com|tiktok\.com|twitter\.com|x\.com/)) {
        return true;
      } else if (this.sns_type == "tiktok" && this.influencer_bulk.match(/instagram\.com|youtube\.com|twitter\.com|x\.com/)) {
        return true;
      } else if (this.sns_type == "twitter" && this.influencer_bulk.match(/instagram\.com|youtube\.com|tiktok\.com/)) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (this.email_private) {
        this.email_to = this.email_private;
      } else {
        this.email_to = this.email;
      }
    },
    request() {
      var emailDomain = this.email.split("@")[1];
      var thisDomain = this.email_to.split("@")[1];
      if (this.influencer_bulk == "") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "リクエストアカウントを入力してください",
        });
      } else if (this.email_is_required && !this.email_to) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "通知先メールアドレスを入力してください",
        });
      } else if (this.email_is_required && emailDomain != thisDomain) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "通知先には" + emailDomain + "のドメインアドレスを入力してください。",
        });
      } else if (this.influencer_bulk.match(/[ぁ-んァ-ヶ亜-熙]+/)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "URLやユーザー名以外の無効な文字列が含まれています。",
        });
      } else if (this.sns_type != "tiktok" && this.sns_type != "youtube" && this.influencer_bulk.match(/[@|＠]+/)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "ユーザー名に無効な文字列(@)が含まれています。",
        });
      } else if (this.youtube_channel_url_error) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "有効ではないチャンネルURLが含まれています。",
        });
      } else if (this.other_sns_error) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "選択されたSNS以外のURLが含まれています。",
        });
      } else {
        this.loading = true;
        var params = new URLSearchParams();
        params.append("sns_type", this.sns_type);
        params.append("request_title", this.request_title);
        params.append("influencer", this.influencer_bulk);
        params.append("email_is_required", this.email_is_required);
        params.append("email_to", this.email_to);
        params.append("token", this.token);
        this.axios
          .post(requestAPI, params)
          .then((response) => {
            if (response.data.noexist_count == 0) {
              this.$alert("リクエストされたインフルエンサーは全て登録済み、または存在しないインフルエンサーです。", "既登録または存在しないインフルエンサーです", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "warning",
              });
            } else if (response.data.exist_count > 0) {
              this.$alert(
                "<div>リクエスト状況は、[リクエスト履歴]でご確認いただけます。<br>下記の" +
                  response.data.exist_count +
                  '名のインフルエンサーは' + this.siteName + 'に既登録、または存在しないためリクエストから除外されました。<div class="import-influencer-noexist"><div>' +
                  response.data.exist_str +
                  "</div>",
                response.data.noexist_count + "名のリクエストを行いました",
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "warning",
                  customClass: "import-influencer",
                }
              );
              this.request_title = "";
              this.resetInfluencerBulk();
              this.closeDrawer();
            } else {
              this.$alert("リクエスト状況は、[リクエスト履歴]でご確認いただけます。", response.data.noexist_count + "名のリクエストを行いました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
              this.request_title = "";
              this.resetInfluencerBulk();
              this.closeDrawer();
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "リクエストに失敗しました",
            });
          });
      }
    },
    verifyEmail() {
      var emailDomain = this.email.split("@")[1];
      var thisDomain = this.email_to.split("@")[1];
      if (emailDomain == thisDomain) {
        this.$store.dispatch("privateEmail", this.email_to);
      } else {
        this.$alert("通知先には" + emailDomain + "のドメインアドレスを入力してください。", "不正なメールアドレスです", {
          confirmButtonText: "OK",
          showCancelButton: false,
          type: "warning",
        });
      }
    },
    closeDrawer() {
      this.$emit("update:request_drawer", false);
    },
    resetInfluencerBulk() {
      this.$emit("update:influencer_bulk", "");
    },
    syncInfluencerBulk() {
      this.$emit("update:influencer_bulk", this.request_value);
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  filters: {},
  watch: {
    request_drawer() {
      this.request_value = this.influencer_bulk;
    },
  },
};
</script>
